import React from "react";
import TelegramSvg from "../../assets/icons/telegram.svg?react";
import WhatsAppSvg from "../../assets/taiga-uikit/icons/message.svg?react";
import { Link } from "../../components/link/link";
import { Logo } from "../../components/Logo/Logo";
import { Text } from "../../components/texts/text";
import {
  _colorText,
  _size,
  _sizeText,
  _style,
  _typeLogo,
  url_telegram,
} from "../../core/core";
import "./Footer.css";

export const Footer: React.FC = () => {
  return (
    <div className="footer">
      <div className="footer-block">
        <div className="footer-header">
          <Logo type={_typeLogo.white} />
          <div className="footer-social">
            <Link
              blank
              link="?chat=true"
              icon_right={<WhatsAppSvg />}
              style={_style.clear}
              size={_size.M}
            />
            <Link
              blank
              link={url_telegram}
              icon_right={<TelegramSvg />}
              style={_style.clear}
              size={_size.M}
            />
          </div>
        </div>

        <div className="footer-body">
          <div className="footer-link-column">
            <Link link="/" size={_size.XS} style={_style.clear}>
              Главная
            </Link>
            <Link link="/uslugi/" size={_size.XS} style={_style.clear}>
              Услуги
            </Link>
          </div>

          <div className="footer-link-column">
            <Link link="/account/" size={_size.XS} style={_style.clear}>
              Личный кабинет
            </Link>
          </div>

          <div className="footer-link-column">
            <Link link="/blog/" size={_size.XS} style={_style.clear}>
              Блог
            </Link>
          </div>
        </div>

        <div className="divider">
          <div className="rectangle-3307"></div>
        </div>

        <div className="footer-bottom">
          <div>
            <Link link="/blog/offerta/" size={_size.XS} style={_style.clear}>
              Публичная оферта.
            </Link>
            <Link link="/blog/policy/" size={_size.XS} style={_style.clear}>
              Политика обработки персональных данных.
            </Link>
            <Link link="/blog/offerta/" size={_size.XS} style={_style.clear}>
              ИП Власов Виталий Владимирович ИНН 752903513223 ОГРН
              323750000021500
            </Link>
          </div>
          <Text size={_sizeText.xs} color={_colorText.neutral}>
            ©HMREP Все&nbsp;права&nbsp;защищены&nbsp;2020- {new Date().getFullYear()}
          </Text>
        </div>
      </div>
    </div>
  );
};
